import React, { useState } from "react";
import "./notesbook.css";

const NotesBook = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div id="rs-latest-news-style7" className=" sec-spacer">
        <div className="container">
          <div className="row rs-latest-list">
            <h2 className="title text-center  mt-2 ">
              📝 TopFaculty{" "}
              <strong style={{ color: "#f7b205" }}> All Notes</strong>
            </h2>

            <div className="card-row">
              <div className="small-card" onClick={() => setShowModal(true)}>
                <div className="card-logo">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ65CiJLzhHKWEhTnDl_WXZ3jKH2B6uSFY_nw&s"
                    alt="Logo"
                  />
                </div>
                <div className="card-content">
                  <h4> 📖 Architecture & Sculpture-Ancient</h4>
                  <p>Medieval and Modern</p>
                </div>
              </div>
            </div>

            {/* Modal */}
            {showModal && (
              <div
                className="custom-modal-overlay"
                onClick={() => setShowModal(false)}
              >
                <div
                  className="custom-modal large"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span
                    className="close-btn"
                    onClick={() => setShowModal(false)}
                  >
                    &times;
                  </span>
                  <div className="modal-header">
                    <h2>📖 Book Overview</h2>
                  </div>
                  <div className="modal-body">
                    <div className="modal-body">
                      <iframe
                        src="https://media.viasacademy.com/Top%20faculty/vedanta%20ias%20pulkit%20sir.pdf%20%20(1).pdf#toolbar=0"
                        title="Book Viewer"
                        className="modal-iframe"
                        frameBorder="1"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button onClick={() => setShowModal(false)}>Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotesBook;
